import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="splash--scroll-reveal"
// CSS hides these elements by default. This controller adds "scroll-reveal-visible"
// when they scroll into view.
//
// Usage:
//   <p data-controller="splash--scroll-reveal">Fades up on scroll</p>
//   <div data-controller="splash--scroll-reveal" data-splash--scroll-reveal-stagger-value="true">
//     <div class="scroll-reveal-item">Card 1</div>
//     <div class="scroll-reveal-item">Card 2</div>
//   </div>
export default class extends Controller {
  static values = {
    stagger: { type: Boolean, default: false },
    delay: { type: Number, default: 80 },
    threshold: { type: Number, default: 0.1 },
  };

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.reveal();
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: this.thresholdValue },
    );
    this.observer.observe(this.element);
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  reveal() {
    if (this.staggerValue) {
      const items = this.element.querySelectorAll(".scroll-reveal-item");
      const count = items.length;
      const maxTotalStagger = 600;
      const perItem = Math.min(this.delayValue, count > 1 ? maxTotalStagger / (count - 1) : 0);

      items.forEach((item, i) => {
        // Ease-out curve: later items compress closer together
        const progress = count > 1 ? i / (count - 1) : 0;
        const eased = 1 - Math.pow(1 - progress, 1.8);
        item.style.transitionDelay = `${Math.round(eased * (count - 1) * perItem)}ms`;
        item.classList.add("scroll-reveal-visible");
      });
    } else {
      this.element.classList.add("scroll-reveal-visible");
    }
  }
}
